import React from "react";
import { ShieldCheck, Hand, Crown, FlaskConical } from "lucide-react";

/* Креативный «магазинный» макет — без 01 02 03 04.
   Один большой featured-блок + три акцентных поверх изображения */
const FEATURED = {
  Icon: ShieldCheck,
  title: "Гарантия на каждую пару",
  text:
    "Если результат вас не устроил — переделаем бесплатно или вернём деньги. Без вопросов и без мелкого шрифта.",
  pull: "Пусть отвечает мастер,\nа не клиент.",
};

const SECONDARY = [
  {
    Icon: Hand,
    title: "Только ручная работа",
    text: "Никаких конвейеров. Каждая пара проходит через руки мастера и трёхэтапный осмотр.",
  },
  {
    Icon: FlaskConical,
    title: "Премиум-составы",
    text: "Saphir, Famaco, Collonil — европейская химия и кожевенные краски, проверенные временем.",
  },
  {
    Icon: Crown,
    title: "14 лет за прилавком",
    text: "Тысячи восстановленных пар: классические оксфорды, винтаж, лимитированные кеды и капризная замша.",
  },
];

const Advantages = () => {
  return (
    <section className="relative section-y border-t-2 border-burgundy" data-testid="advantages-section">
      <div className="container-x">
        {/* Заголовок-манифест */}
        <div className="max-w-5xl">
          <h2 className="font-heading text-5xl md:text-7xl lg:text-8xl heading-tight text-ink">
            Старая школа.
            <br />
            <span className="accent text-burgundy">Новые материалы.</span>
          </h2>
          <p className="mt-8 max-w-2xl lede text-ink/85">
            Мы не работаем «на потоке». Каждая пара — отдельная задача и отдельная история. Поэтому к нам приезжают и из соседних городов.
          </p>
        </div>

        {/* Асимметричный grid */}
        <div className="mt-16 md:mt-24 grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          {/* Featured */}
          <article
            className="lg:col-span-7 lg:row-span-2 relative bg-burgundy text-cream p-8 md:p-12 lg:p-16 overflow-hidden group"
            data-testid="advantage-featured"
          >
            {/* фоновая огромная иконка */}
            <FEATURED.Icon
              size={420}
              strokeWidth={0.5}
              className="absolute -right-20 -bottom-20 text-cream/8 pointer-events-none"
            />
            <div className="relative">
              <div className="stamp !text-cream !border-cream">главное</div>
              <h3 className="mt-8 font-heading text-4xl md:text-6xl lg:text-7xl heading-tight">
                {FEATURED.title}
              </h3>
              <p className="mt-6 max-w-xl body-rich text-cream/90">
                {FEATURED.text}
              </p>
              <p
                className="accent text-gold-light text-2xl md:text-4xl mt-10 max-w-md leading-snug whitespace-pre-line"
                data-testid="advantage-pull-quote"
              >
                «{FEATURED.pull}»
              </p>
            </div>
          </article>

          {/* Secondary blocks */}
          {SECONDARY.map((adv, idx) => {
            const Icon = adv.Icon;
            return (
              <article
                key={adv.title}
                className="lg:col-span-5 relative bg-cream-paper border-2 border-burgundy p-8 md:p-10 group hover:bg-burgundy hover:text-cream transition-colors duration-500"
                data-testid={`advantage-secondary-${idx}`}
              >
                <div className="flex items-start gap-5">
                  <div className="shrink-0 w-14 h-14 border-2 border-burgundy flex items-center justify-center text-burgundy group-hover:bg-cream group-hover:border-cream transition-colors">
                    <Icon size={24} strokeWidth={1.75} />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-heading text-2xl md:text-3xl text-ink group-hover:text-cream transition-colors">
                      {adv.title}
                    </h3>
                    <p className="mt-3 body-rich-italic text-muted_ink group-hover:text-cream/85 transition-colors">
                      {adv.text}
                    </p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
